import { createContext, MutableRefObject, useContext } from 'react';

export const EditButtonRefContext = createContext<MutableRefObject<HTMLAnchorElement | null>>({ current: null });
export const useEditButtonRefContext = () => useContext(EditButtonRefContext);
